<div id="alert" class="toast flex right-2 toast-end fixed bottom-18 z-999 whitespace-normal">
  <div class="flex flex-col items-end" data-testid="toast-list" (mouseenter)="paused.set(true)" (mouseleave)="paused.set(false)">
    @for (entry of renderedToasts(); track entry.toast.id) {
      @let toast = entry.toast;
      @let rank = entry.rank;
      <div
        [attr.role]="rank >= 0 && rank < 2 ? 'status' : null"
        [attr.data-testid]="rank === 2 ? 'toast-queue' : null"
        class="rounded-sm shadow-lvl2 relative overflow-hidden pl-4 max-w-fit origin-top transition-all duration-250 ease-out starting:opacity-0 starting:translate-y-2 starting:scale-95"
        [ngClass]="{
          'max-h-0 py-0 mt-0 opacity-0 -translate-y-1 scale-95 pointer-events-none': rank === -1,
          'z-20 max-h-11 mt-1 py-3 pr-9 text-sm': rank >= 0 && rank < 2,
          'z-10 max-h-7 -mt-1.5 py-1.5 pr-3 text-xs font-medium scale-x-92 opacity-90 pointer-events-none': rank === 2,
          'bg-success text-success-content': toast.type === 'success',
          'bg-secondary text-secondary-content': toast.type === 'info',
          'bg-error text-error-content': toast.type === 'error',
        }"
      >
        <div class="flex items-center justify-between gap-2">
          <span [attr.data-testid]="rank >= 0 && rank < 2 ? 'toast-message' : null" [class.opacity-75]="rank === 2">{{
            toast.message
          }}</span>
          @if (rank === 2) {
            <span class="shrink-0 font-semibold" data-testid="toast-queue-count">+{{ queuedCount() }}</span>
          }
        </div>
        @if (rank >= 0 && rank < 2) {
          <button
            type="button"
            class="btn btn-ghost btn-circle btn-xs absolute top-1 right-1 text-current"
            aria-label="Meldung schließen"
            data-testid="toast-close"
            (click)="close(toast.id)"
          >
            <ng-icon name="heroXMark" size="14" />
          </button>
          <progress
            class="progress h-1 absolute bottom-0 left-0 rounded-none rounded-b-sm w-full text-grey-900/40"
            [value]="toast.progress"
            max="100"
          ></progress>
        }
      </div>
    }
  </div>
  <ng-container #viewSnackContainer></ng-container>
</div>
